import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCWQg-yPbcxrdlN_JRxW_Vc63vQBFAFdvg",
    authDomain: "greatcalcy-530b6.firebaseapp.com",
    projectId: "greatcalcy-530b6",
    storageBucket: "greatcalcy-530b6.firebasestorage.app",
    messagingSenderId: "135156079654",
    appId: "1:135156079654:web:8a96c481f00636fc451ae7",
    measurementId: "G-58ECXC8EZ5"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);